var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemographics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242 611 c-8 -4 -14 -12 -15 -17 -1 -12 -42 -44 -56 -44 -7 0 -23 7 -36 16 -22 14 -27 14 -69 -5 -56 -24 -64 -49 -9 -26 20 9 39 18 42 20 2 3 19 -5 38 -16 l34 -21 33 26 c19 14 40 27 47 28 17 4 29 18 29 36 0 14 -19 16 -38 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 546 c-68 -29 -104 -105 -91 -187 7 -42 44 -123 78 -172 l19 -27 -30 -26 c-17 -14 -31 -34 -31 -43 0 -61 133 -94 200 -49 46 31 49 58 10 91 l-31 27 40 66 c69 114 77 211 24 275 -47 55 -123 73 -188 45z m149 -65 c26 -27 31 -39 31 -81 0 -43 -5 -54 -33 -82 -47 -48 -117 -48 -164 0 -28 28 -33 39 -33 81 0 52 25 92 70 112 37 16 96 3 129 -30z m-66 -379 c20 18 66 7 60 -14 -11 -33 -145 -33 -156 0 -6 21 40 32 61 14 15 -14 19 -14 35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 470 c-4 -6 -4 -14 -1 -17 3 -3 1 -12 -5 -19 -7 -9 -8 -32 -4 -64 5 -39 11 -50 25 -50 14 0 20 11 25 50 4 27 3 55 -1 62 -5 7 -9 19 -9 27 0 18 -21 26 -30 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 490 c0 -33 -3 -40 -20 -40 -15 0 -20 7 -20 25 0 14 -4 25 -10 25 -5 0 -10 -11 -10 -25 0 -14 -4 -25 -10 -25 -5 0 -10 -4 -10 -10 0 -6 47 -10 120 -10 73 0 120 4 120 10 0 6 -4 10 -10 10 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 -18 -10 -40 0 -33 -3 -40 -20 -40 -15 0 -20 7 -20 25 0 14 -4 25 -10 25 -5 0 -10 -11 -10 -25 0 -18 -5 -25 -20 -25 -17 0 -20 7 -20 40 0 22 -4 40 -10 40 -5 0 -10 -18 -10 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 291 c-11 -5 -31 -21 -45 -36 -21 -23 -25 -36 -25 -95 -1 -41 -6 -74 -14 -84 -11 -13 -11 -19 -1 -31 12 -14 15 -14 30 0 10 9 21 15 26 14 5 -1 11 0 14 1 3 1 29 3 57 3 45 2 57 7 85 35 28 28 33 39 33 82 0 42 -5 54 -31 81 -33 33 -92 46 -129 30z m100 -56 c33 -32 33 -78 0 -110 -32 -33 -78 -33 -110 0 -50 49 -15 135 55 135 19 0 40 -9 55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 215 c-7 -9 -10 -18 -7 -22 8 -7 37 15 37 28 0 14 -16 11 -30 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemographics);
export default __webpack_public_path__ + "static/media/demographics.ea04e1f119821b1ac7a611b452ffc94d.svg";
export { ForwardRef as ReactComponent };